import React from 'react'
import styled from '@nobia/zeus-components/lib/styled'
// import { FormattedMessage } from '@nobia/zeus-components/lib/i18n'
// import { Route, Switch } from '@nobia/zeus-components/lib/router'
import { Container } from '@nobia/zeus-components/lib/grid'
import { OverlayDestination } from '@nobia/zeus-components/lib/overlay'
import LandingPage from '../pages/landing-page/LandingPage'

const Wrapper = styled.div`
  text-align: center;
`

const App = () => (
  <Wrapper>
    <Container>
      <LandingPage />
      {/*
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route>
          <p>
            <FormattedMessage id="app.not-found.message" />
          </p>
        </Route>
      </Switch> */}
    </Container>
    <OverlayDestination />
  </Wrapper>
)

export default App
